import { Teaser as t } from '@xprog/prensa/types'

export const TeaserVideoLeft: t.TeaserProps = {
  css: {
    backgroundColor: 'transparent',
    padding: '$0',
    mb: '$3',
    width: '100%',
    '@lg': {
      ml: '$8',
      mb: '$8',
      width: 'calc(100% - $8)'
    },
    '.TeaserImageContainer': {
      mr: '$3',
      width: 'calc(50% - $3)'
    },
    '.TeaserSubtitle': {
      display: 'none',
      '@lg': {
        display: 'flex'
      }
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitleText': {
      color: '#989898',
      fontSize: '14px',
      lineHeight: '18px',
      fontWeight: 400,
      '@lg': {
        fontSize: '18px',
        lineHeight: '22px',
        fontWeight: 400,
      }
    },
    '.TeaserTitle': {
      color: '#f5f5f5',
      my: '$3'
    },
    '.TeaserTitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%',
      '@lg': {
        fontSize: '25px',
        lineHeight: '30px',
      }
    },
    '.TeaserWrap': {
      ml: '$3',
      maxWidth: 'calc(50% - $3)',
      width: '100%'
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md'
}